const alt = require('components/alt');
const UrlHelpers = require('components/shared/url_helpers.js');
const Cart = require('./cart.js');
const { V3 } = require('components/api_request');

class CartActions {
  cartLoaded(response) {
    return response;
  }

  loadCart() {
    return V3.get(
      UrlHelpers.apiCartPath
    ).then((response) => {
      const cart = new Cart(response);
      this.cartLoaded(cart);
    });
  }
}

module.exports = alt.createActions(CartActions);



// WEBPACK FOOTER //
// ./javascripts/components/cart/cart_actions.js